import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { refreshTokenAction } from '../../actions/refreshTokenActions';
import { logoutUserAction } from '../../actions/authenticationActions';
import { getStorage, setStorage } from '../../utils/browserStorage';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import * as staticConfigs from '../../configs/staticConfigs';

class refreshTokenComponent extends Component {

    componentDidMount(){
        let userGroupData = userGroupUrlCheck(this.props.location);
        let username      = '';
        let unid          = '';
        if(userGroupData!==undefined){
            username      = userGroupData.username;
            unid          = userGroupData.unid;
        }
        this.props.refreshTokenAction({username: username,unid:unid});
    }
 
    render() {
 
        let loginRoute = '';
        //console.log(this.props.status)
        if(this.props.status){
            if(this.props.location.pathname.includes(staticConfigs.LOGIN_ROUTE_SUPER_ADMIN)){
                let userGroupData = userGroupUrlCheck(this.props.location);
                let username      = '';
                let unid          = '';
                let fcmToken = getStorage('fcmNotificationToken');
                if(userGroupData!==undefined){
                    username      = userGroupData.username;
                    unid          = userGroupData.unid;
                }
                this.props.logoutUserAction({username: username,unid:unid,fcm_token:fcmToken,device_type:1});
                loginRoute = staticConfigs.LOGIN_ROUTE_SUPER_ADMIN;
                localStorage.removeItem("super");
            }else if(this.props.location.pathname.includes(staticConfigs.LOGIN_ROUTE_AFFILIATE)){
                let userGroupData = userGroupUrlCheck(this.props.location);
                let username      = '';
                let unid          = '';
                let fcmToken = getStorage('fcmNotificationToken');
                if(userGroupData!==undefined){
                    username      = userGroupData.username;
                    unid          = userGroupData.unid;
                }
                this.props.logoutUserAction({username: username,unid:unid,fcm_token:fcmToken,device_type:1});
                loginRoute = staticConfigs.LOGIN_ROUTE_AFFILIATE;
                localStorage.removeItem("affiliate");
            }else if(this.props.location.pathname.includes(staticConfigs.LOGIN_ROUTE_CLIENT)){
                let userGroupData = userGroupUrlCheck(this.props.location);
                let username      = '';
                let unid          = '';
                let fcmToken = getStorage('fcmNotificationToken');
                if(userGroupData!==undefined){
                    username      = userGroupData.username;
                    unid          = userGroupData.unid;
                }
                this.props.logoutUserAction({username: username,unid:unid,fcm_token:fcmToken,device_type:1});
                loginRoute = staticConfigs.LOGIN_ROUTE_CLIENT; 
                localStorage.removeItem("client");
            }else{
                loginRoute = staticConfigs.LOGIN_ROUTE_SUPER_ADMIN; 
                //localStorage.clear();
            }
        }  

        return (
            <React.Fragment>
                {this.props.status!=0 && (

                    <Redirect to={loginRoute}/>
                )} 
            </React.Fragment>
        )    
    }
}

const mapStateToProps = (state) => {  
    return {
        // logout : state.refreshToken.data,
        status: state.refreshToken.status,
        activity: state.refreshToken.activity,
        tokenData: state.refreshToken.data
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        refreshTokenAction:refreshTokenAction,  
        logoutUserAction:logoutUserAction  
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(refreshTokenComponent);